import React from 'react';

import connectToStores from 'alt/utils/connectToStores';

import ShiftStore from '../stores/ShiftStore';
import ChatStore from '../stores/ChatStore';

import ChatActions from '../actions/ChatActions';
import checkOverflow from "../utils/checkModalOverflow";

@connectToStores
class MessageModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            messagePosted: false,
            message: '',
            isLoading: false
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.chStore.messageSent && !this.props.chStore.messageSent) {
            this.setState({isLoading: false, messagePosted: true});
            ChatStore.getMessages({'shift': this.props.shiftId});
            this.toggleModal();
        }

        if (this.props.isVisible !== nextProps.isVisible) {
            checkOverflow(nextProps.isVisible);
        }
    }

    static getPropsFromStores() {
        return {
            sStore: ShiftStore.getState(),
            chStore: ChatStore.getState()
        };
    }

    static getStores() {
        return [ShiftStore, ChatStore];
    }

    render() {
        let classes = "modal-overlay send-message-modal-overlay";
        if (this.props.isVisible) classes += " active";

        return (
            <div onClick={this.toggleModal.bind(this)} className={classes}>
                <div onClick={this.modalClick.bind(this)} className="modal whitebox">
                    <header className="modal-header">
                        <h1>Send a message</h1>
                        <button className="close" onClick={this.toggleModal.bind(this)}><span>&times;</span></button>
                    </header>

                    {this.renderForm()}
                </div>
            </div>
        );
    }

    renderForm() {
        return (
            <div className="modal-content modal-content-form">
                <div className="message">
                    <div className="label-title">Message</div>
                    <textarea ref="messageBox" value={this.state.message} onChange={this.textChange.bind(this)} className="message-modal-editor" />
                </div>

                <div className="buttons">
                    {this.getSendButton()}
                    <button className="btn-transparent" onClick={this.toggleModal.bind(this)}>Cancel</button>
                </div>
            </div>
        );
    }

    getSendButton() {
        let sendMessageButton = <button className="btn btn-green btn-small" onClick={this.sendMessage.bind(this)}>Send message</button>;
        if (this.state.isLoading) {
            sendMessageButton = <button className="btn btn-green btn-small"><div className="bounce1"></div><div className="bounce2"></div><div className="bounce3"></div></button>;
        }
        return sendMessageButton;
    }

    textChange(e) {
        this.setState({message: e.target.value});
    }

    sendMessage() {
        this.setState({isLoading: true});
        const data = {};
        data.message = this.state.message.replace(/<\/?[^>]+(>|$)/g, "");
        data.sender = this.props.user.profile.id;
        data.hiring = this.props.hiringId;
        if (data.message) {
            ChatStore.sendMessage(data);
            this.setState({
                message: ''
            });
        }
    }

    modalClick(evt) {
        evt.stopPropagation();
    }

    toggleModal() {
        setTimeout(() => {ChatActions.clearMessageSent()}, 50);
        this.props.toggleModal();
    }
}

export default MessageModal;



/** WEBPACK FOOTER **
 ** ./app/src/components/MessageModal.js
 **/